import * as z from 'zod';

/**
 * TanStack Router normalizza i query param PRIMA della validazione
 * (`defaultParseSearch`): `?x=1` arriva come `number`, `?x=true` come
 * `boolean` e un parametro ripetuto (`?x=a&x=b`) come array. Uno schema
 * `z.string()` o `z.boolean()` su quei valori fa fallire `validateSearch`, e
 * il fallimento non degrada al parametro assente: abbatte la route intera
 * sull'ErrorFallback. Un parametro sporco nell'URL non deve mai costare la
 * pagina, quindi questi helper accettano qualunque input e scartano ciò che
 * non è del tipo atteso.
 */
export const optionalStringParam = z
  .unknown()
  .optional()
  .transform((value) => (typeof value === 'string' ? value : undefined));

export const optionalBooleanParam = z
  .unknown()
  .optional()
  .transform((value) => (typeof value === 'boolean' ? value : undefined));

/**
 * Parametro di filtro delle liste (`useSearchParamsForm`): un valore inatteso
 * diventa "nessun filtro" invece di far cadere la rotta. Stringa anche quando
 * il router rilegge `?accountId=3` come numero: le combobox hanno id stringa.
 * Stessa forma dei filtri del backoffice (`optionalSearchString`).
 */
export const optionalSearchString = () =>
  z.coerce.string().nullish().catch(undefined);

/** Interruttore di filtro nell'URL: un valore non booleano vale assente. */
export const optionalSearchBoolean = () =>
  z.boolean().nullish().catch(undefined);
